// used for creating a flat structure for emitting event
import Vue from 'vue';
export default new Vue();